import React, { useState, useEffect } from 'react';
import { Button, Card, CardHeader, Table, Container, Row, Col } from 'reactstrap';
import { api } from '../../../../api';
import Cookies from 'js-cookie';

const Report2 = () => {
  const [reportData, setReportData] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [loading, setLoading] = useState(false);

  const emp_id = Cookies.get('token');

  const handleGenerateReport = async () => {
    const company_id = Cookies.get('company_id');
    let url = `pdfgenarate.php?engineer_task_id=${emp_id}&company_id=${company_id}`;

    if (selectedYear && selectedMonth) {
      url += `&year=${selectedYear}&month=${selectedMonth}`;
    } else if (selectedYear) {
      url += `&year=${selectedYear}`;
    } else if (selectedMonth) {
      url += `&month=${selectedMonth}`;
    }

    try {
      const response = await api.get(url);
      const path = response.data.path;
      console.log('PDF path from backend:', path);

      // Updated path handling for both production and local environments
      const baseURL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? 'http://localhost:8000/'
        : 'https://aecp.aecearth.io/'; // Use your production domain

      // Remove any leading slash from path to avoid double slashes
      const fileUrl = baseURL + path.replace(/^\/+/, '');

      // Open in new tab
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    }  catch (error) {
      console.error('Error fetching report:', error);
    }
  };

  const months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 5; i <= currentYear + 15; i++) {
    years.push(i);
  }

  const fetchData = () => {
    setLoading(true);
    const company_id = Cookies.get('company_id');
    let url = `viewtaskByID.php?id=${emp_id}&company_id=${company_id}`;
    if (selectedYear && selectedMonth) {
      url += `&year=${selectedYear}&month=${selectedMonth}`;
    } else if (selectedYear) {
      url += `&year=${selectedYear}`;
    } else if (selectedMonth) {
      url += `&month=${selectedMonth}`;
    }

    api
      .get(url)
      .then((response) => {
        setReportData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedMonth]);

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="mb-5" />
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                <CardHeader className="border-0">
                  <Row className="align-items-center flex-column flex-lg-row text-center text-lg-left">
  {/* Header */}
  <div className="col-12 col-lg d-flex justify-content-center justify-content-lg-start mb-2 mb-lg-0">
    <h3 className="mb-0 font-bold">Task Details</h3>
  </div>

  {/* Year + Month dropdowns and Button */}
  <div className="col-12 col-lg d-flex flex-column flex-lg-row justify-content-center justify-content-lg-end align-items-center gap-2">
    {/* Year + Month dropdowns side-by-side */}
    <div className="d-flex flex-row justify-content-center gap-2 mb-2 mb-lg-0">
      <select
        className="form-control"
        value={selectedYear}
        style={{
          width: '120px',
          color: 'black',
          border: '1px solid black',
        }}
        onChange={e => setSelectedYear(e.target.value)}
      >
        <option value="">Year</option>
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <select
        className="form-control"
        value={selectedMonth}
        style={{
          width: '120px',
          color: 'black',
          border: '1px solid black',
        }}
        onChange={e => setSelectedMonth(e.target.value)}
      >
        <option value="">Month</option>
        {months.map(month => (
          <option key={month.value} value={month.value}>
            {month.label}
          </option>
        ))}
      </select>
    </div>

    {/* Button below dropdowns on small screens, inline on lg+ */}
    <Button
      style={{
        backgroundColor: '#d86f89',
        borderColor: '#d86f89',
        color: 'black',
        minWidth: '150px',
      }}
      onClick={handleGenerateReport}
    >
      <span className="d-none d-md-inline d-lg-none">Report</span>
      <span className="d-inline d-md-none d-lg-inline">Generate Report</span>
    </Button>
  </div>
</Row>

                </CardHeader>
                <Table id="report-table" className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">SL.No</th>
                      <th scope="col">Projects</th>
                      <th scope="col">Task</th>
                      <th scope="col">Due</th>
                      <th scope="col">StartTime</th>
                      <th scope="col">Description</th>
                      <th scope="col">Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportData && reportData.length > 0 ? (
                      reportData.map((item, index) => (
                        <tr key={index}>
                          <th scope="row">{index + 1}</th>
                          <td>{item.p_name}</td>
                          <td>{item.taskname}</td>
                          <td>{item.end_date ? item.end_date.split(' ')[0] : ''}</td> {/* Due */}
                          <td>{item.start_date ? item.start_date.split(' ')[0] : ''}</td> {/* StartTime */}
                          <td>{item.t_description.replace(/<[^>]*>?/gm, '')}</td>
                          <td>{item.time_taken_formatted}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: 'center' }}>
                          No Tasks available for selected year and month.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Report2;
